"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const VoxeetRTCNative_1 = __importDefault(require("./VoxeetRTCNative"));
const debug_1 = __importDefault(require("debug"));
const AudioProcess_1 = __importDefault(require("../AudioProcess"));
const MediaStream_1 = require("../../models/MediaStream");
const bowser_1 = __importDefault(require("bowser"));
/**
 * @ignore
 */
const browser = bowser_1.default.getParser(window.navigator.userAgent);
/**
 * @ignore
 */
const debug = debug_1.default('vxt:rtc:uplan');
class VoxeetRTCUnifiedPlan extends VoxeetRTCNative_1.default {
    constructor(options = {}) {
        super(options);
    }
    onAddTrack(peerId, peer, e) {
        debug('stream onAddTrack', e);
        // For audio/video input renegociation on chrome
        if (e.track && e.track.kind === 'audio') {
            const pos = this.getPeerPosition(peerId);
            if (this.audioContext) {
                if (peer.process) {
                    peer.process.disconnect();
                }
                peer.process = new AudioProcess_1.default(this.audioContext, e.target, false, this.audio3D);
                peer.process.connect();
            }
            this.setPeerPosition(peerId, pos.x, pos.y);
        }
        this.updateStreamEvent(peerId, e.target);
    }
    onRemoveTrack(peerId, e) {
        debug('stream onRemoveTrack', e);
        const isScreenStream = e.currentTarget.id.search('screen_') !== -1;
        if (isScreenStream) {
            this.removeScreenStream(peerId, e.target);
        }
        else {
            if (!e.target.getTracks().length) {
                this.removeStreamEvent(peerId, e.target);
                return;
            }
            this.updateStreamEvent(peerId, e.target);
        }
    }
    addTrackListeners(peerIdOld, peerOld, position, connection) {
        return __awaiter(this, void 0, void 0, function* () {
            connection.ontrack = (evt) => {
                //debug("ontrack", evt, evt.streams, evt.streams[0].getVideoTracks());
                let stream = evt.streams[0];
                if (stream) {
                    // Fix for msid not received after before adding the screenshare
                    let peerId = this.checkStream(stream);
                    let peer = this.peers.find((item) => item.peerId === peerId);
                    if (!peer) {
                        peer = {
                            peerId: peerId,
                            connection: null,
                            stream: null,
                            process: null,
                            isMaster: false,
                        };
                        this.peers.push(peer);
                    }
                    peer.closed = false;
                    if (evt.streams[0].id.search('screen_') === -1) {
                        if (evt.streams[0].getAudioTracks().length > 0) {
                            if (this.audioContext) {
                                peer.process = new AudioProcess_1.default(this.audioContext, evt.streams[0], false, this.audio3D);
                                peer.process.connect();
                            }
                            evt.streams[0].getAudioTracks()[0].enabled = true;
                            // if (position && this.audioContext) {
                            //   peer.process.setPosition(position.x, position.y); // In case of renegociation
                            // }
                        }
                        //evt.streams[0].onaddtrack = e => this.onAddTrack(peerId, peer, e);
                        evt.streams[0].onremovetrack = (e) => this.onRemoveTrack(peerId, e);
                        if (!peer.stream) {
                            this.addStreamEvent(peerId, evt.streams[0]);
                        }
                        else {
                            this.updateStreamEvent(peerId, evt.streams[0]);
                        }
                        peer.stream = evt.streams[0];
                    }
                    else {
                        //Screen sharing
                        evt.streams[0].onremovetrack = (e) => this.onScreenRemoveTrack(peerId, e);
                        this.remoteScreenStream = evt.streams[0];
                        this.remoteScreenStream.type = MediaStream_1.MediaStreamType.ScreenShare;
                        setTimeout(() => {
                            if (peer.sharedScreen && peer.sharedScreen === true) {
                                this.updateScreenStreamEvent(peerId, evt.streams[0]);
                            }
                            else {
                                this.addScreenStreamEvent(peerId, evt.streams[0]);
                                peer.sharedScreen = true;
                            }
                        }, 1);
                    }
                }
            };
            connection.onremovestream = (evt) => {
                debug('onremovestream', evt);
                if (evt.stream.id.search('screen_') !== -1) {
                    const stream = evt.stream;
                    if (!stream)
                        return;
                    let peerId = this.checkStream(stream);
                    let peer = this.peers.find((item) => item.peerId === peerId);
                    if (peer && peer.hasOwnProperty('sharedScreen')) {
                        delete peer.sharedScreen;
                    }
                    //this.removeScreenStreamEvent();
                }
            };
        });
    }
}
exports.default = VoxeetRTCUnifiedPlan;
